const validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmail = email => validEmail.test(email)

export const isPaidAccount = currentAccount => currentAccount?.period?.includes('monthly') || currentAccount?.period?.includes('yearly')

export const isAdmin = currentUser => currentUser?.type === 'admin'
